import HttpViewerConfigClient from '../http-viewerConfigClient';

export default {
    /**
     * Checks if the Voice Change is available
     * @param {string} twitchAuthToken
     * @param {string} channelId
     * @param {string} voiceId
     * @returns
     */
    isVoiceChangeAvailable(twitchAuthToken, channelId, voiceId) {
        const requestConfig = {
            headers: {
                'Custom-Authorization': `Bearer ${twitchAuthToken}`,
                'Content-Type': 'application/json',
            },
        };

        return HttpViewerConfigClient.get(`/user/${channelId}/voice/${voiceId}`, requestConfig);
    },
};
